export default __webpack_public_path__ + "static/media/share-img.9694870c.jpg";